import * as THREE from 'three';
import { isVector3Like } from '../checking';

/**
 * Converts a point to a THREE.Vector3.
 * If the point is already a THREE.Vector3, it returns a copy of it.
 * @param point
 * @param target
 * @returns
 */
export const toVec3 = (
  point:
    | THREE.Vector3
    | THREE.Vector3Tuple
    | number
    | number[]
    | ArrayLike<number>
    | THREE.Vector3Like,
  target: THREE.Vector3 = new THREE.Vector3(),
): THREE.Vector3 => {
  return isVector3Like(point)
    ? target.copy(point)
    : target.fromArray(typeof point === 'number' ? [point, point, point] : point);
};
